import React from 'react';

export const MixPanelContext = React.createContext({
  track: (...args: any[]) => {},
});
